export default function Footer() {
  return (
    <footer id="footer" className="py-14 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">色影视</span>
            </div>
            <p className="text-sm text-background-100/50 leading-relaxed">
              色影视致力于为中文用户提供高清流畅的在线影视观看体验。电视剧全集在线、电影完整版播放、综艺全集免费看，不缓冲追剧连续播放，最新影视剧集一网打尽。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#index" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">影视索引</a>
              <a href="#media" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">精彩集锦</a>
              <a href="#cards" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">精选推荐</a>
              <a href="#about" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">关于我们</a>
              <a href="#faq" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">影视分类</h4>
            <div className="space-y-2.5">
              <a href="#index" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">古装剧集</a>
              <a href="#index" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">悬疑推理</a>
              <a href="#index" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">都市情感</a>
              <a href="#index" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">科幻动作</a>
              <a href="#index" className="block text-sm text-background-100/50 hover:text-background-100 transition-colors cursor-pointer">动漫专区</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-100/50 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。如有合作意向，欢迎通过联系邮箱与我们沟通。
            </p>
            <div className="mt-4">
              <p className="text-xs text-background-100/30 mb-1">联系邮箱</p>
              <p className="text-sm text-background-100/50">feedback@seyingshi.tv</p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-100/30">
            &copy; 2026 色影视 · 本站内容仅供学习交流，版权归原作者所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-100/30 hover:text-background-100/50 transition-colors cursor-pointer">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}